
const APIFORMULARIOA05INICIALES = 'https://www.ancogenecop.com/APIANCO/controllers/funcionesPdf.php?op=';




export const obtenerCrg = async (consecutivo) => {
    //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
     const data = new FormData();
    data.append('CONSECUTIVO', consecutivo);
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'traeCrg', {
            method: 'POST',
            body: data
        });
         return await response.json();
    } catch (error) {
        console.error('Error en obtenerConsecutivo:', error);
        return [];
    }
};


export const obtenerPadres = async (rowData) => {
    //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
     const data = new FormData();
    data.append('CHIP_PADRE', rowData.CHIP_PADRE);
    data.append('CHIP_MADRE', rowData.CHIP_MADRE);
    data.append('CHIP', rowData.CHIP);
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'traePadres', {
            method: 'POST',
            body: data
        });
         return await response.json();
    } catch (error) {
        console.error('Error en obtenerPadres:', error);
        return [];
    }
};


export const obtenerAbuelos = async (rowData) => {
    //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
    
     const data = new FormData();
    data.append('CHIP_PADRE', rowData.CHIP_PADRE);
    data.append('CHIP_MADRE', rowData.CHIP_MADRE);
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'traeAbuelos', {
            method: 'POST',
            body: data
        });
         return await response.json();
    } catch (error) {
        console.error('Error en obtenerAbuelos:', error);
        return [];
    }
};

// export const obtenerBisAbuelos = async (rowData) => {
//     //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
    
//      const data = new FormData();
//     data.append('CHIP_PADRE', rowData.CHIP_PADRE);
//     data.append('CHIP_MADRE', rowData.CHIP_MADRE);
//     try {
//         const response = await fetch(APIFORMULARIOA05INICIALES + 'traeBisAbuelos', {
//             method: 'POST',
//             body: data
//         });
//          return await response.json();
//     } catch (error) {
//         console.error('Error en obtenerAbuelos:', error);
//         return [];
//     }
// };

export const obtenerGenealogia = async () => {
    //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
    
     const data = new FormData();
    
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'traeGenealogia', {
            method: 'POST',
            body: data
        });
         return await response.json();
    } catch (error) {
        console.error('Error en obtenerGenealogia:', error);
        return [];
    }
};

export const obtenerParametros = async () => {
    //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
    
     const data = new FormData();
    
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'traeParametros', {
            method: 'POST',
            body: data
        });
         return await response.json();
    } catch (error) {
        console.error('Error en traerParametros:', error);
        return [];
    }
};


